<template>
  <div class="pm-dialog-bit">

    <div class="flex justify-center">
      <div class="flex items-center justify-center">
        <vs-input
          class="pm-dialog-bit-input"
          :class="[ left ? 'input-any' : 'input-null' ]"
          :style="{ border: this.selectedInput !== 1 ? '2px solid #2d9cdb' : '2px solid #f2f2f2', 'border-radius': '8px'}"
          @mousedown="selectedInput = 0"
          label=""
          v-model="left"
          v-validate="'required'"
          name="left"
          data-vv-as="left"
          ref="left"
        />
      </div>
      <div v-show="requiredLeft" class="position-required-left">
        <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8"  :style="{ color: '#2d9cdb' }" />
      </div>
      <div class="w-1/6 mt-4 flex items-center justify-center">
      〜
      </div>
      <div>
        <vs-input
          class="pm-dialog-bit-input"
          :class="[ right ? 'input-any' : 'input-null' ]"
          :style="{ border: this.selectedInput === 1 ? '2px solid #2d9cdb' : '2px solid #f2f2f2', 'border-radius': '8px'}"
          @mousedown="selectedInput = 1"
          label=""
          v-model="right"
          v-validate="'required'"
          name="right"
          data-vv-as="right"
          ref="right"
        />
      </div>
      <div v-show="requiredRight" class="position-required-right">
        <feather-icon icon="CheckCircleIcon" svgClasses="h-8 w-8"  :style="{ color: '#2d9cdb' }" />
      </div>
    </div>

    <div class="flex justify-center">
      <div class="vs-row flex justify-start" style="width:64%;">
        <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index" @mousedown="onKeyDown(master.value)">
          <vs-chip class="pm-input-key" >
            {{ master.value }}
          </vs-chip>
        </div>
        <div class="vs-col candidate-list" @mousedown="toggleRequired"  style="margin:0.2rem;">
          <vs-chip class="pm-input-key" color="#09151c">
            必須
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <div class="flex justify-end" style="width:64%;" @mousedown="onClear">
        <vs-chip
          class="pm-input-key clear-button"
        >クリア</vs-chip>
      </div>
    </div>
    <div class="flex justify-center">
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedInput: 0,
      selectedId: -1,
      left: "",
      right: "",
      requiredLeft: false,
      requiredRight: false,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['bit'];
    },
    enableSave() {
      return true; // ( this.left || this.right );
    },
  },
  methods: {
    initData() {

      this.left         = this.valueMap && this.valueMap.left ? this.valueMap.left : "";
      this.requiredLeft = this.valueMap && this.valueMap.left_options ? this.valueMap.left_options.required : false;

      this.right         = this.valueMap && this.valueMap.right ? this.valueMap.right : "";
      this.requiredRight = this.valueMap && this.valueMap.right_options ? this.valueMap.right_options.required : false;

      this.selectedInput = 0;
      this.$refs.left.focusInput()
    },
    onKeyDown(key){
      if ( this.selectedInput !== 1) {
        const el = this.$refs.left.$refs.vsinput;
        const index = el.selectionStart;
        this.left = this.left ? (this.left.substring(0, index) + key + this.left.substring(index)) : key;
        el.focus();
        el.setSelectionRange(index + key.length , index + key.length);
        this.$nextTick(() => {
          el.setSelectionRange(index + key.length , index + key.length);
          Vue.$log.debug("bitLeftValue cursor", index, el.selectionStart );
        });
      }
      if ( this.selectedInput === 1) {
        const el = this.$refs.right.$refs.vsinput;
        const index = el.selectionStart;
        this.right = this.right ? (this.right.substring(0, index) + key + this.right.substring(index)) : key;
        el.focus();
        el.setSelectionRange(index + key.length , index + key.length);
        this.$nextTick(() => {
          el.setSelectionRange(index + key.length , index + key.length);
          Vue.$log.debug("bitRightValue cursor", index, el.selectionStart );
        });
      }
    },
    onClear() {
      if ( this.selectedInput !== 1) {
        this.left = "";
        this.requiredLeft = false;
      }
      if ( this.selectedInput === 1) {
        this.right = "";
        this.requiredRight = false;
      }
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = ["update"]
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")

      let updateKeyValueMap = {};

      updateKeyValueMap[this.columnKey + "#left"] = this.left;
      updateKeyValueMap[this.columnKey + "#left_options"] = {};
      updateKeyValueMap[this.columnKey + "#left_options"]['required'] = this.requiredLeft ? this.requiredLeft : false;

      updateKeyValueMap[this.columnKey + "#right"] = this.right;
      updateKeyValueMap[this.columnKey + "#right_options"] = {};
      updateKeyValueMap[this.columnKey + "#right_options"]['required'] = this.requiredRight ? this.requiredRight : false;

      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
    toggleRequired() {
      if ( this.selectedInput === 0) {
        this.requiredLeft = !this.requiredLeft;
      } else {
        this.requiredRight = !this.requiredRight;
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-bit {
  .vs-input--input {
    height: 3rem;
    text-align: center;
    background-color: $pm-white;
  }
  .pm-dialog-bit-input {
    width: 6rem;
    margin: 1rem;
  }
  .input-any {
    input {
      background-color: $pm-white;
      border: 1px solid $pm-blue;
    }
  }
  .input-null {
    input {
      background-color: $pm-light-gray;
      border: none;
    }
  }
  .position-required-left {
    position:relative;
    top: -5px;
    left: -15px;
  }
  .position-required-right {
    position:relative;
    top: -5px;
    left: -15px;
  }
  .candidate-list {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
    &:hover {
      background-color: $pm-blue;
      border: 1px solid $pm-blue;
      color: $pm-white !important;
    }
  }
  .clear-button {
    margin-top: 0;
    margin-bottom: 1.6rem;
    border-radius: 5px;
    font-size: 120%;
    min-width:2rem;
    height: 2.6rem;
    width: 8rem;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

